import React from 'react';
import './ProfileTabs.css';

const ProfileTabs = ({ tabs, active, onChange }) => (
  <div className="pt-tabs">
    {tabs.map((t) => (
      <button
        key={t.key}
        className={`pt-tab${active === t.key ? ' active' : ''}`}
        onClick={() => onChange(t.key)}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default ProfileTabs;